import { API, Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { Table, TableCell, TableHead, TableRow } from '@aws-amplify/ui-react';
import SavedSearchRow from './SavedSearchRow.jsx';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { 
  SortUp,
  SortDown
} from 'react-bootstrap-icons';
const SavedSearchTable = (props) => {
  const [entities, setEntities] = useState([])
  const [isBusy, setIsBusy] = useState(false);
  const getsearches = async () => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    API.get("DocumentSearchUser", "/savedsearches", requestInfo)
      .then(response => {
        setIsBusy(false);
        let newEntities = response
        console.log(response)
        setEntities(newEntities)
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
      })
  };
  useEffect(() => { getsearches() }, [])
  const handleSelect = (entity) => {
  };
  const handleDelete = async (entity) => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    API.get("DocumentSearchUser", `/deletereport?reportid=${entity.id}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        let index = entities.indexOf(entity)
        if (index >= 0){
          let newEntities = [...entities];
          newEntities.splice(index, 1)
          setEntities(newEntities)
        }
        else 
          console.log('index not found')
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
      })
  };
  
  const sortColumn = (column,direction) => {
    if (column === 'report_name') {
     if (direction === 'up') {
       const sorted = [...entities].sort((a,b) => { return a.report_name.localeCompare(b.report_name)})
       setEntities(sorted)
     } 
     else {
       const sorted = [...entities].sort((a,b) => { return b.report_name.localeCompare(a.report_name)})
       setEntities(sorted)
     }
    }
    else if (column === 'type') {
     if (direction === 'up') {
       const sorted = [...entities].sort((a,b) => { return a.type.localeCompare(b.type)})
       setEntities(sorted)
     } 
     else {
       const sorted = [...entities].sort((a,b) => { return b.type.localeCompare(a.type)})
       setEntities(sorted)
     }
    }
    else {
      if (direction === 'up') {
       const sorted = [...entities].sort((a,b) => { return a.date.localeCompare(b.date)})
       setEntities(sorted)
      }  
      else {
       const sorted = [...entities].sort((a,b) => { return b.date.localeCompare(a.date)})
       setEntities(sorted)
      }
    }
  }
  return (
    <>
      <Row>
        <Col>
          <br />
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Saved Searches</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col>
          <h1>Saved Searches</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Row>
        <Col>
          <Table className='table table-striped'>
            <TableHead className='thead-dark'>
              <TableRow>
                <TableCell>
                  <strong>Search Name </strong>
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('report_name', 'up')}>
                    <SortUp />
                  </Button>         
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('report_name', 'down')}>
                    <SortDown />
                  </Button>
                </TableCell>
                <TableCell>
                  <strong>Search Type </strong>
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('type', 'up')}>
                    <SortUp />
                  </Button>         
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('type', 'down')}>
                    <SortDown />
                  </Button>
                </TableCell>
                <TableCell>
                  <strong>Search Date </strong>
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('date', 'up')}>
                    <SortUp />
                  </Button>         
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('date', 'down')}>
                    <SortDown />
                  </Button>
                </TableCell>
                <TableCell><strong>      </strong></TableCell>
              </TableRow>
            </TableHead>
            <tbody>
              {
                entities.map((thisEntity, index) => {
                  return (
                    <SavedSearchRow key={thisEntity.id} index={index} entity={thisEntity} onDelete={handleDelete} onSelect={handleSelect} />
                  )
                })
              }
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  )
}


export default SavedSearchTable;